import useTranslation from '@Queries/useTranslation';
import Img from '@UI/Img';
import Link from '@UI/Link';
import styles from './Category.module.css';

import type { FC, HTMLAttributes } from 'react';

interface CategoryProps extends HTMLAttributes<HTMLDivElement> {
  id: string;
  title: string;
  img: string;
  onLinkClick?: (id: string) => void;
}

const Category: FC<CategoryProps> = (props) => {
  const { id, title, img, onLinkClick, ...restProps } = props;
  const { t } = useTranslation();

  const handleClick = () => {
    if (!onLinkClick) return;

    onLinkClick(id);
  };

  return (
    <div {...restProps}>
      <Img src={img} alt={title} className={styles.img} />
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <Link underlined view='primary' className={styles.link} onClick={handleClick}>
          {t('decision.blocks.link')}
        </Link>
      </div>
    </div>
  );
};

export default Category;
